import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down_arrow",
  "use": "icon-down_arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down_arrow\"><path d=\"M249.1392 358.4h525.7216c17.1008 0 32.5632 9.6256 39.936 24.6784a43.008 43.008 0 0 1-5.3248 46.08l-262.8608 322.56a44.7488 44.7488 0 0 1-69.2224 0L214.528 429.056a43.008 43.008 0 0 1-5.3248-46.08 44.4416 44.4416 0 0 1 39.936-24.6784z\" p-id=\"11071\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol